import { render, staticRenderFns } from "./Scales.vue?vue&type=template&id=53184bd4&"
import script from "./Scales.vue?vue&type=script&lang=js&"
export * from "./Scales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports